import { render, staticRenderFns } from "./SchoolActivityRanking.vue?vue&type=template&id=5b4f0c30&scoped=true"
import script from "./SchoolActivityRanking.vue?vue&type=script&lang=js"
export * from "./SchoolActivityRanking.vue?vue&type=script&lang=js"
import style0 from "./SchoolActivityRanking.vue?vue&type=style&index=0&id=5b4f0c30&prod&lang=scss&scoped=true"
import style1 from "./SchoolActivityRanking.vue?vue&type=style&index=1&id=5b4f0c30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f0c30",
  null
  
)

export default component.exports